import { useEffect, useState } from "react";

/** Se a media query casa agora, e muda junto com a janela (girar o celular,
 * alargar a janela). Antes morava escondida em `ListaLicitacoes`; a Home e
 * Oportunidades passaram a precisar da mesma pergunta (2026-10-02). */
export function useMidia(q: string) {
  const [sim, setSim] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const m = window.matchMedia(q);
    const muda = () => setSim(m.matches);
    muda();
    m.addEventListener("change", muda);
    return () => m.removeEventListener("change", muda);
  }, [q]);
  return sim;
}
